module.exports = __webpack_public_path__ + "media/images/top/icon/white/ico-medal-4a7d875b514b42c733080ea2e6705c5a.svg";